import { ContentError } from './errors'

const DEFAULT_TIMEOUT_MS = 15_000

/** 所有外部请求共用超时与错误翻译；业务层只看到 ContentError。 */
export async function fetchWithTimeout(
  input: RequestInfo | URL,
  init: RequestInit = {},
  timeoutMs = DEFAULT_TIMEOUT_MS,
): Promise<Response> {
  const controller = new AbortController()
  const timer = setTimeout(() => controller.abort(), timeoutMs)

  try {
    return await fetch(input, { ...init, signal: controller.signal })
  } catch (error) {
    if (error instanceof DOMException && error.name === 'AbortError') {
      throw new ContentError('timeout', `请求超过 ${Math.round(timeoutMs / 1000)} 秒没有响应`)
    }
    throw new ContentError('network', error instanceof Error ? error.message : String(error))
  } finally {
    clearTimeout(timer)
  }
}

export function retryAfterOf(response: Response): string | undefined {
  return response.headers.get('retry-after') ?? undefined
}
